module.exports = __webpack_public_path__ + "static/media/challange2.faf62812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/challange2.jpg
// module id = 483
// module chunks = 0